import FilterListIcon from '@mui/icons-material/FilterList';
import { IconButton, Menu, MenuItem, Tooltip } from '@mui/material';
import ModalPagarLMCarpetas from '@/components/Modals/ModalPagarLMCarpetas';
import { useState } from 'react';
import { useTablaCarpetaContext } from '../../logics/TablaCarritoProvider';

export default function FilterHeaderMenu() {
    const { context } = useTablaCarpetaContext();
    const { carpetas, informes } = context;


    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const [openModal, setOpenModal] = useState(false);


    const handleClick = (event: any) => {
        setAnchorEl(event.currentTarget);
    };

    const handlePagarLM = () => {
        setOpenModal(true);
        setAnchorEl(null);
    };

    return (
        <>
            <Tooltip title="Utilidades">
                <IconButton onClick={handleClick}>
                    <FilterListIcon />
                </IconButton>
            </Tooltip>
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handlePagarLM}
            >
                <MenuItem onClick={handlePagarLM}>Pagar LM de página actual</MenuItem>
            </Menu>

            <ModalPagarLMCarpetas
                carpetas={carpetas}
                informes={informes}
                open={openModal}
                onCancel={() => setOpenModal(false)}
                onCarpetasPagadas={(carpetas) => {
                   context.refetchCarpetas();
                }}
            />
        </>
    );
}